import { useState } from "react"

export default ()=>{
	const [collapsed,setCollapsedSatte]=useState(false);
	const setCollapsed=()=>setCollapsedSatte(!collapsed);
	return {
		collapsed,
		setCollapsed
	}
}